import React, { useRef, useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import CardPromoModal from "../components/CardPromoModal";
import BackHeader from "../components/BackHeader";
import Slider from "react-slick";
import CardDisplayCard from "../components/CardDisplayCard";
import Button from "../components/Button";
import StatusDialog from "../components/StatusDialog";
import "react-responsive-carousel/lib/styles/carousel.min.css"; // requires a loader
import { Carousel } from "react-responsive-carousel";

export const Cards = () => {
    const settings = {
        dots: false,
        infinite: true,
        speed: 500,
        slidesToShow: 1,
        slidesToScroll: 1,
        arrows: false,
        autoplay: false,
        swipe: true,
        accessibility: true,
    };
    const sliderRef = useRef(null);
    const [isModalOpen, setIsModalOpen] = useState(true);

    const openModal = () => setIsModalOpen(true);
    const closeModal = () => setIsModalOpen(false);
    const [isOpen, setIsDailogOpen] = useState(false);
    const [isLearnMore, setIsLearnMore] = useState(false);
    const navigate = useNavigate();

    const cards = [
        { id: 1, url: "./images/store/card_1.png" },
        { id: 2, url: "./images/store/card_2.png" },
        { id: 3, url: "./images/store/card_3.png" },
    ];

    const handleJoinWaitlist = () => {
        console.log("Join waitlist clicked");
        closeModal();
    };

    const openDialog = () => {
        setIsDailogOpen(true);
    };

    const closeDialog = () => {
        setIsDailogOpen(false);
    };

    const toggleLearnMore = () => {
        setIsModalOpen(!isModalOpen);
        setIsLearnMore(!isLearnMore);
    };

    if (isModalOpen) {
        return (
            <CardPromoModal
                isOpen={isModalOpen}
                onClose={() => navigate(-1)}
                title="GET YOUR MAPEX CARD NOW!"
                subtitle="Join our Waitlist to be the first to hear when our cards become available"
                image="./images/store/illustrationImage.png"
                bgImage="./images/store/cards-bg.png"
                primaryButtonText="Join Our Waitlist"
                secondaryButtonText="Learn More"
                onPrimaryClick={handleJoinWaitlist}
                onSecondaryClick={toggleLearnMore}
            />
        );
    }

    const items = Array.from({ length: 20 }).map((_, i) => ({
        id: i,
        src: `https://picsum.photos/500?idx=${i}`,
    }));

    return (
        <div
            className="px-3"
            style={{
                background: "#000000",
                height: "100%",
                backgroundImage: isLearnMore
                    ? "url('./images/store/cards-bg.png')"
                    : "url('./images/store/recent_activity_bg.png')",
                backgroundRepeat: "no-repeat",
                backgroundPosition: "0px 0px",
                backgroundSize: isLearnMore ? "contain" : "cover",
                backgroundColor: "#000000",
            }}
        >
            {/* main content */}
            {!isLearnMore && (
                <div className="pt-4">
                    <BackHeader title="Mapex Card" />
                    <Slider
                        ref={(slider) => (sliderRef.current = slider)}
                        {...settings}
                        className="mx-2 py-2"
                        draggable={true}
                    >
                        {cards.map((card) => (
                            <Card key={card.id} url={card.url} />
                        ))}
                    </Slider>

                    <div>
                        <p
                            style={{
                                color: "#6765FF",
                                fontSize: "10px",
                            }}
                            className="mt-3"
                        >
                            THE BENIFIT
                        </p>
                        <h3
                            style={{
                                fontSize: "36px",
                            }}
                        >
                            The Secure, Global & Rewarding Way to Spend
                        </h3>
                    </div>

                    <div>
                        <CardDisplayCard
                            title="Seamless Spending with Global Acceptance"
                            description="The MAPex Card is accepted anywhere major cards are supported, including online platforms, retail stores, and ATMs worldwide."
                            bulletPoints={[
                                "Why It Matters? Use your earnings effortlessly for everyday purchases, travel, or subscriptions without worrying about currency conversions or compatibility.",
                            ]}
                            icon={"./images/store/seamless_icon.png"}
                            className="mt-4"
                        />

                        {/* Example with custom icon */}
                        <CardDisplayCard
                            title="Cashback Rewards & Exclusive Discounts"
                            description=""
                            bulletPoints={[
                                " Convert your MAC tokens or investment earnings into cash instantly through the MAPex app.",
                                "Why It Matters? Gain immediate access to your funds whenever you need them, ensuring liquidity and flexibility.",
                            ]}
                            icon={"./images/store/cashback_icon.png"}
                            className="mt-4"
                        />
                        <CardDisplayCard
                            title="Instant Exchange & Cash Access"
                            description=""
                            bulletPoints={[
                                "Earn cashback on every purchase made with the MAPex Card, credited directly in MAC tokens. Enjoy exclusive discounts at partner merchants and eco-friendly brands.",
                                "Why It Matters? Maximize your spending power while earning additional rewards for future investments or staking.",
                            ]}
                            icon={"./images/store/exchange_icon.png"}
                            className="mt-4"
                        />
                        <CardDisplayCard
                            title="Advanced Security Features"
                            description=""
                            bulletPoints={[
                                "The MAPex Card includes cutting-edge security measures such as biometric authentication, instant freeze functionality, and dynamic spending limits.",
                                "Why It Matters? Protect your funds with state-of-the-art safeguards, giving you peace of mind for every transaction.",
                            ]}
                            icon={"./images/store/sec_icon.png"}
                            className="mt-4"
                        />

                        <Button className="mt-5 mb-5" onClick={openDialog}>
                            Join Our Waitlist
                        </Button>
                        <StatusDialog
                            isOpen={isOpen}
                            onClose={closeDialog}
                            type="success"
                            title="Congratulations!"
                            message="You've successfully joined the MAPex Card waiting list! You will be notified via email to set up your delivery address and receive your card."
                            buttonText="Continue Exploring"
                        />
                    </div>
                </div>
            )}
            {isLearnMore && (
                <div className="pt-4">
                    <BackHeader title="Mapex Card" onClick={toggleLearnMore} />
                    <h2 style={{ fontSize: "24px", fontWeight: "bold" }}>
                        The Secure, Global & Rewarding Way to Spend
                    </h2>
                    <p style={{ fontSize: "13px", color: "#fff" }}>
                        The MAPEX Card is your gateway to seamless spending,
                        earning rewards, and contributing to sustainability-all
                        without relying on traditional banks.
                    </p>
                    <p style={{ fontSize: "13px", color: "#fff" }}>
                        Designed for Matrix Apex (Mapex) investors, this card
                        will be available for order at the same time as the MAC
                        coin launch, giving early adopters immediate access to
                        both tools.
                    </p>
                    <div
                        style={{
                            height: "1px",
                            borderRadius: "50px",
                            background: "#fff",
                        }}
                        className="my-4"
                    />

                    <div className="mt-3">
                        <h2 style={{ fontSize: "32px", fontWeight: "bold" }}>
                            Key Features of the Mapex Card
                        </h2>
                        <p className="p-with-li">
                            1. Global Acceptance
                            <li>
                                Use the Mapex Card anywhere Visa or Mastercard
                                is accepted-online, in-store, or at ATMs
                                worldwide.
                            </li>
                        </p>
                        <p className="p-with-li">
                            2. Cashback Rewards
                            <li>
                                Earn up to 5% cashback on all purchases,
                                credited directly in MAC tokens.
                            </li>
                        </p>
                        <p className="p-with-li">
                            3. Loyalty Points
                            <li>
                                Accumulate loyalty points with every
                                transaction, exchangeable for MAC tokens.
                            </li>
                        </p>
                        <p className="p-with-li">
                            4. Instant Conversion
                            <li>
                                Convert MAC tokens into fiat or stablecoins
                                instantly through the Mapex app.
                            </li>
                        </p>
                        <p className="p-with-li">
                            5. Enhanced Security
                            <li>
                                Protect your funds with biometric
                                authentication, dynamic spending limits, and
                                instant freeze capabilities.
                            </li>
                        </p>
                        <p className="p-with-li">
                            6. Multi-Currency Support
                            <li>
                                Spend in any currency with no hidden fees or
                                unfavorable exchange rates.
                            </li>
                        </p>
                        <p className="p-with-li">
                            7. Carbon Offset Contributions.
                            <li>
                                A small percentage of every purchase funds green
                                projects, helping you make a positive
                                environmental impact.
                            </li>
                        </p>
                        <p className="p-with-li">
                            8. Real-Time Insights
                            <li>
                                Track your spending, analyze trends, and manage
                                budgets through the Mapex app.
                            </li>
                        </p>
                        <p className="p-with-li">
                            9.Zero Fees
                            <li>
                                Enjoy no annual fees, foreign transaction fees,
                                or ATM withdrawal fees (up to a specified
                                limit).
                            </li>
                        </p>
                        <p className="p-with-li">
                            10. Customizable Design
                            <li>
                                Personalize your card with eco-friendly or
                                futuristic designs that reflect your values.
                            </li>
                        </p>

                        <div
                            style={{
                                height: "1px",
                                borderRadius: "50px",
                                background: "#fff",
                            }}
                            className="my-4"
                        />
                    </div>

                    <div className="mt-3">
                        <h2 style={{ fontSize: "32px", fontWeight: "bold" }}>
                            How It Works
                        </h2>
                        <p className="p-with-li">
                            1. Order During MAC Coin Launch
                            <li>
                                Order your Mapex Card at the same time as the
                                MAC coin public sale.
                            </li>
                            <li>
                                Link your wallet and start using the card
                                immediately after activation.
                            </li>
                        </p>
                        <p className="p-with-li">
                            2. Spend Globally
                            <li>
                                Use the card for everyday purchases, travel, or
                                online shopping.
                            </li>
                        </p>
                        <p className="p-with-li">
                            3. Earn While Spending
                            <li>
                                Automatically earn cashback and loyalty points
                                with every transaction.
                            </li>
                        </p>
                        <p className="p-with-li">
                            4. Track and Manage
                            <li>
                                Monitor your spending, rewards, and carbon
                                offset contributions through the Mapex app.
                            </li>
                        </p>

                        <div
                            style={{
                                height: "1px",
                                borderRadius: "50px",
                                background: "#fff",
                            }}
                            className="my-4"
                        />
                    </div>

                    <div className="mt-3">
                        <h2 style={{ fontSize: "32px", fontWeight: "bold" }}>
                            Why Choose the Mapex Card?
                        </h2>
                        <p className="p-with-li">
                            <li>
                                <span>Freedom from Banks: </span>
                                Order your Mapex Card at the same time as the
                                MAC coin public sale.
                            </li>
                        </p>
                        <p className="p-with-li">
                            <li>
                                <span>Earning While Spending: </span>
                                Grow your wealth with cashback and loyalty
                                rewards in MAC tokens.
                            </li>
                        </p>
                        <p className="p-with-li">
                            <li>
                                <span>Sustainability: </span>
                                Make a positive environmental impact with every
                                purchase.
                            </li>
                        </p>
                        <p className="p-with-li">
                            <li>
                                <span>Global Convenience: </span>
                                Spend anywhere in the world without worrying
                                about fees or compatibility.
                            </li>
                        </p>

                        <div
                            style={{
                                height: "1px",
                                borderRadius: "50px",
                                background: "#fff",
                            }}
                            className="my-4"
                        />
                    </div>

                    <div>
                        <h2
                            style={{
                                fontSize: "32px",
                                fontWeight: "bold",
                            }}
                        >
                            Unlock the future of finance with the Mapex Card.
                        </h2>
                        <p
                            className="text-white"
                            style={{
                                fontSize: "13px",
                            }}
                        >
                            Order yours during the MAC coin launch and start
                            earning rewards while spending smarter. Be among the
                            first to experience the power of the Matrix Apex
                            ecosystem-secure your Mapex Card today!
                        </p>
                    </div>

                    <Button
                        className="mt-5 mb-5"
                        onClick={() => setIsLearnMore(!isLearnMore)}
                    >
                        Get Your Mapex Card
                    </Button>
                </div>
            )}
            {/* main content */}
        </div>
    );
};

const Card = ({ title, description, url }) => {
    return (
        <div className="mx-1 text-white card-style shadow-card d-flex justify-content-center align-items-center position-relative">
            <img
                alt="Card"
                src={url}
                style={{
                    height: "451px",
                }}
            />
        </div>
    );
};
